module.exports = __webpack_public_path__ + "media/images/covid19-laptop-screen-f8241e37.png";